import { atom, onMount, task } from 'nanostores'

import listCountries from '@/services/listCountries'
import type { CountryList } from '@/services/schemas'

const $countries = atom<CountryList['data']>([])

onMount($countries, () => {
  task(async () => {
    $countries.set(await listCountries())
  })
})

export {
  $countries,
}
